import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { http } from "@/lib/api";

/**
 * BillingCanceled — Stripe redirects here when the user closes /
 * cancels the hosted checkout. Offers a retry path back into the same
 * Stripe session-creation flow without forcing them to re-register.
 */
export default function BillingCanceled() {
    const retry = async () => {
        try {
            const r = await http.post("/billing/start-trial", {
                origin_url: window.location.origin,
            });
            if (r?.data?.url) window.location.href = r.data.url;
        } catch {
            /* surfacing fine — page already shows the manual CTA below */
        }
    };

    return (
        <div
            className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#03122b] px-6 text-center text-white"
            data-testid="billing-canceled-page"
        >
            <div className="pointer-events-none absolute inset-0 grid-bg opacity-[0.12]" />
            <div className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.04] p-9 backdrop-blur-xl">
                <XCircle size={32} className="text-[#f59e0b]" />
                <h1 className="mt-5 font-display text-2xl font-bold tracking-tight">
                    Checkout cancelled
                </h1>
                <p className="mt-2 text-sm text-white/65">
                    Your account is created but the Professional plan isn't active yet.
                    You can retry the payment any time, or sign in and use the Starter
                    tier in the meantime.
                </p>
                <div className="mt-7 flex flex-col gap-2.5">
                    <button
                        type="button"
                        onClick={retry}
                        data-testid="billing-canceled-retry"
                        className="rounded-lg bg-gradient-to-r from-[#00C2FF] to-[#5b5ef0] px-5 py-3 text-xs font-semibold uppercase tracking-[0.22em] text-white shadow-lg transition hover:brightness-110"
                    >
                        Retry checkout
                    </button>
                    <Link
                        to="/"
                        data-testid="billing-canceled-dashboard"
                        className="rounded-lg border border-white/15 bg-white/[0.04] px-5 py-3 text-xs font-semibold uppercase tracking-[0.22em] text-white/85 transition hover:border-[#00C2FF]/50 hover:bg-white/[0.08]"
                    >
                        Go to dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
}
